var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlgo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.185 31 4.339-7.513L14.862 16l4.313-7.513.714-1.19.316 1.19 1.323 4.947L20.047 16l-4.34 7.487L11.398 31h5.185l4.339-7.513 2.25-3.89 1.058 3.89L26.238 31h4.656l-2.01-7.513L26.874 16l-.53-1.931 3.227-5.583h-4.708l-.158-.556-1.64-6.136L22.851 1h-4.524l-.106.159-4.233 7.327L9.65 16 5.34 23.487.999 31h5.185z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlgo);
export default __webpack_public_path__ + "static/media/ALGO.e030a08a3a4b80a88da44112750dee09.svg";
export { ForwardRef as ReactComponent };